import React, { Component } from 'react'
import { Row, Col, Tab } from 'react-bootstrap'
import VideoClips from './VideoClips'
import VideoPlayerAnnotations from './VideoPlayerAnnotations'
import PlayerStatistics from './PlayerStatistics'
import EvaluationTabs from './EvaluationTabs'
import ShareVideoModal from './components/ShareVideoModal'

class MainContent extends Component {
    constructor(props) {
        super(props)

        this.state = {
            activeTab: 'video',
            insertedImages: '',
            showModal: ''
        }
    }

    render() {
        return (
            <div className="main-content">
                <Tab.Container id="player-evaluation-main-tab-container" activeKey={this.state.activeTab} defaultActiveKey={this.state.activeTab} unmountOnExit>
                    <Row className="gutters-12">
                        <Col md={3}>
                            {this.renderLeftSideContent()}
                        </Col>
                        <Col md={6}>
                            {this.renderCenterContent()}
                        </Col>
                        <Col md={3}>
                            {this.renderRightSideContent()}
                        </Col>
                    </Row>
                </Tab.Container>
                {this.renderModals()}
            </div>
        )
    }

    renderLeftSideContent = () => {
        return (
            <MainContent.VideoClips
                list={this.cardsList}
                actions={{
                    video: (id) => this.changeTabHandler('video', id),
                    statistics: (id) => this.changeTabHandler('statistics', id),
                    share: (id) => this.openShareModalHandler(id),
                    download: (id) => this.downloadVideoHandler(id)
                }}
            />
        )
    }

    renderCenterContent = () => {
        return (
            <Tab.Content>
                <Tab.Pane eventKey="video">
                    <MainContent.VideoPlayerAnnotations
                        onImageInsert={this.insertImageHandler}
                        onShareVideoClicked={(videoUrl) => this.openShareModalHandler(videoUrl)}
                    />
                </Tab.Pane>
                <Tab.Pane eventKey="statistics">
                    <MainContent.PlayerStatistics />
                </Tab.Pane>
            </Tab.Content>
        )
    }

    renderRightSideContent = () => {
        return (
            <MainContent.EvaluationTabs
                insertedImage={this.state.insertedImage}
            />
        )
    }

    renderModals = () => {
        const { showModal } = this.state;
        return (
            <ShareVideoModal show={showModal === 'share-video'} onHide={() => this.hideModal()} />
        )
    }

    /**
     * Handlers
     */

    changeTabHandler = (newTab, videoId) => {
        this.setState({ activeTab: newTab })
    }

    insertImageHandler = (insertedImage) => {
        this.setState({
            insertedImage
        })
    }

    openShareModalHandler = (id) => {
        this.setState({ showModal: 'share-video' });
    }

    hideModal = () => {
        this.setState({ showModal: '' });
    }

    downloadVideoHandler = (id) => {

    }

    cardsList = [
        {
            id: 5,
            title: 'Hardfoot FC VS Sunrisers FC (2-0)',
            text: '12/31/2019 6:00PM | Goodison Park',
            items: [
                {
                    id: 51,
                    title: '98:00 Min',
                }
            ]
        },
        {
            id: 6,
            title: 'Hardfoot FC VS Sunrisers FC (2-0)',
            text: '12/31/2019 6:00PM | Goodison Park',
            items: [
                {
                    id: 61,
                    title: '98:00 Min',
                }
            ]
        },
        {
            id: 7,
            title: 'Hardfoot FC VS Sunrisers FC (2-0)',
            text: '12/31/2019 6:00PM | Goodison Park',
            items: [
                {
                    id: 71,
                    title: '98:00 Min',
                }
            ]
        },
        {
            id: 8,
            title: 'Hardfoot FC VS Sunrisers FC (2-0)',
            text: '12/31/2019 6:00PM | Goodison Park',
            items: [
                {
                    id: 81,
                    title: '98:00 Min',
                }
            ]
        },
    ]
}

MainContent.VideoClips = VideoClips;
MainContent.EvaluationTabs =EvaluationTabs;
MainContent.VideoPlayerAnnotations = VideoPlayerAnnotations;
MainContent.PlayerStatistics = PlayerStatistics;

export default MainContent;